import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";

export default async function resetPassword(email: string): Promise<boolean> {
    if (!email || email.length < 3) {
        toast.error("Invalid email");
        return false;
    }

    const resetPromise = async () => {
        const { error } = await supabase.auth.resetPasswordForEmail(email);

        if (error) {
            throw new Error(error.message);
        }

        return true;
    };

    try {
        const result = await toast.promise(
            resetPromise(),
            {
                pending: "Sending reset email...",
                success: "Password reset email sent!",
                error: "Failed to send reset email"
            }
        );
        return result;
    } catch (err) {
        console.log("Reset password error:", err);
        return false;
    }
}
